<template>
<div>
  <nav class="nav-poss noselect">
    <div class="nav-wrapper blue-color-background">
      <div class="col s12">
        <a :href="homeUrl" class="logo"><img :src="logo" /></a>
        <div class="gradient"></div>
        <ul class="right">
          <search-bar></search-bar>

          <status-bar></status-bar>

          <application-switch></application-switch>

          <alarm-list></alarm-list>

          <li>
            <a v-on:click.stop="toggleVolumeMenu()" v-show="!soundMuted"><i class="material-icons right">volume_up</i>&nbsp;</a>
            <a v-on:click.stop="toggleVolumeMenu()" v-show="soundMuted"><i class="material-icons right">volume_off</i>&nbsp;</a>
            <div class="volume-menu z-depth-1" v-on:click.stop v-if="volumeMenu">
              <h6>{{ $t('views.navbar.volume') }}</h6>
              <div class="row">
                <div class="col s8">
                  <input class="blue-color" v-model="volume" type="range" min="0" max="1" step="0.1" />
                </div>
                <div class="col s2">
                  <a class="btn-flat blue-color" v-show="!soundMuted" v-on:click.stop="toggleMuteSound()"><i class="material-icons">volume_up</i></a>
                  <a class="btn-flat grey-color" v-show="soundMuted" v-on:click.stop="toggleMuteSound()"><i class="material-icons">volume_off</i></a>
                </div>

                <div class="col s2">
                  <a class="btn-flat blue-color" v-on:click.stop="testSound()">{{ $t('views.navbar.test') }}</a>
                </div>
              </div>
            </div>
          </li>

          <li v-show="currentUser.DashboardId && currentUser.DashboardId !== null">
            <dashboard></dashboard>
          </li>

          <li v-show="showLanguagePicker">
            <div class="dropdown-width language-dropdown">
              <a
                class="valign-wrapper dropdown-trigger grey-color cursor-hand"
                data-target='ddOperationalMode'>
                <img
                  class="flag-size"
                  :src="require('../../assets/country/' + locale + '.png')">
              <i></i></a>

              <!-- Dropdown language -->
              <!-- LINK TO FLAGS: https://www.iconfinder.com/iconsets/flags_gosquared
              (free for commercial use) -->

              <ul
                id='ddOperationalMode'
                class='dropdown-content' >
                <li
                  v-for="lang in locales"
                  :key="lang">
                  <a
                    class="grey-color no-padding center-align cursor-hand"
                    @click="changeLanguage(lang)" >
                    <img :src="require('../../assets/country/' + lang + '.png')">
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li class="clickable" v-on:click.stop="toggleUserMenu()">
            <div class="background-hover"></div>
            <a v-bind:class="{'blue-color-background': userMenu}" class=" btn-logout btn-floating text-black">{{currentUser.UserName.substring(0, 1)}}</a>
            <div class="user-menu z-depth-1 menu-text" v-if="userMenu">
              <table class="striped highlight">
                <tbody>
                  <tr class="clickable" @click="navigateTo('termsofservice')">
                    <td>{{ $t('views.navbar.termsofservices') }}</td>
                  </tr>
                  <tr class="clickable" @click="navigateTo('support')">
                    <td>{{ $t('views.navbar.support') }}</td>
                  </tr>
                  <tr class="clickable">
                    <!-- <td>{{ $t('views.navbar.manuals') }}</td> -->
                    <td class="no-padding"><a class="menu-item-trackside" target="_blank" :href="tracksideUrl">Trackside</a></td>
                  </tr>
                   <tr class="clickable">
                    <!-- <td>{{ $t('views.navbar.manuals') }}</td> -->
                    <td class="no-padding"><a class="menu-item-menual" target="_blank" :href="gettingStarted">{{ $t('views.navbar.manualversion') }}</a></td>
                  </tr>
                  <!--
                  <tr class="clickable" @click="navigateTo('diagnose')">
                    <td>{{ $t('views.navbar.diagnose') }}</td>
                  </tr>-->
                  <tr class="mouse-pointer">
                    <td>&nbsp;</td>
                  </tr>
                  <tr class="clickable" @click="navigateTo('userPage')">
                    <td>{{ currentUser.UserName }}</td>
                  </tr>
                  <!--<tr class="clickable" @click="navigateTo('settings')">
                    <td>{{ $t('views.navbar.settings') }}</td>
                  </tr>-->
                  <tr class="clickable" @click="navigateTo('logout')">
                    <td >{{ $t('views.navbar.signout') }}</td>
                  </tr>
                  <tr >
                    <td style="font-size: 10px; text-align: bottom; float: left;color: rgba(0, 0, 0, 0.56);">{{version}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
</template>

<script>
import Vue from 'vue'
import router from '../../router'
import AuthenticationService from '../../services/AuthenticationService'
import VueWorker from 'vue-worker'
import UtilitiesService from '../../services/UtilitiesService'
import SoundService from '../../services/SoundService'
import SearchBar from './_SearchBar.vue'
import StatusBar from './_StatusBar.vue'
import AlarmList from './_AlarmList.vue'
import Dashboard from './_Dashboard.vue'
import ApplicationSwitch from './_ApplicationSwitch.vue'
import Translation from '../../i18n/Translation.js'
import LanguageService from '../../services/api/LanguageService'
import UsersApi from '@/services/api/UsersApi'
import M from 'materialize-css'

Vue.use(VueWorker)

var searchTimer = null

export default {
  name: 'NavBar',
  props: ['railObjects'],
  components: {
    'search-bar': SearchBar,
    'status-bar': StatusBar,
    'alarm-list': AlarmList,
    'dashboard': Dashboard,
    'application-switch': ApplicationSwitch
  },
  data () {
    return {
      gettingStarted: require('@/assets/documents/POSS_Getting_Started.pdf'),
      tracksideUrl: process.env.VUE_APP_BASE_URL_TRACKSIDE,
      logo: require('@/assets/logo-strukton-systems.jpg'),
      currentUser: AuthenticationService.getUser(),
      userMenu: false,
      volumeMenu: false,
      volume: SoundService.getVolume(),
      soundMuted: SoundService.isMuted(),
      locales: [],
      locale: Translation.getCurrentLanguage(),
      version: process.env.VERSION
    }
  },
  computed: {
    showLanguagePicker () {
      return this.$route.path === '/' || this.$route.path.startsWith('/dashboard')
    },
    homeUrl () {
      if (!this.currentUser) return '#/'
      const id = this.currentUser.DashboardId
      return (id != null && id !== 'undefined') ? `#/dashboard${id}` : '#/'
    }
  },
  beforeCreate: function () {
  },
  created: function () {
  },
  beforeMount () {
    LanguageService.getLanguages()
      .then(response => {
        response.data.forEach(element => {
          this.locales.push(element.Translation)
        })
      })
      .catch(e => {
      })
  },
  mounted: function () {
    M.Sidenav.init(document.getElementById('.sidenav'), {})
    this.$root.$el.addEventListener('click', this.rootClick)

    var elem = document.querySelector('.dropdown-trigger')
    var ddcontainelem = document.querySelector('.dropdown-width')
    var options = {
      container: ddcontainelem,
      constrainWidth: false
    }
    M.Dropdown.init(elem, options)
  },
  methods: {
    navigateTo (application) {
      switch (application) {
        case 'termsofservice':
          router.push('/termsofservice')
          break
        case 'support':
          router.push('/support')
          break
        case 'manuals':
          router.push('/manuals')
          break
        case 'diagnose':
          router.push('/diagnose')
          break
        case 'userPage':
          router.push('/possusers/' + this.currentUser.UserId)
          break
        case 'settings':
          router.push('/settings')
          break
        case 'logout':
          this.userMenu = false
          AuthenticationService.logOut()
          // this.$eventHub.$emit('authenticated', false)
          break
      }
    },
    changeLanguage (newValue) {
      Translation.setLanguage(newValue).then((language) => {
        UsersApi.getUser(this.currentUser.UserId).then(result => {
          const user = result.data
          if (user !== null) {
            LanguageService.getLanguagesV2().then(languages => {
              languages.data.forEach(x => {
                if (x.CultureCode === language) {
                  user.LanguageId = x.Id
                  UsersApi.postUser(user).then(result => {
                    this.$notify({
                      group: 'alerts',
                      type: 'success',
                      title: 'Save user',
                      text: 'User saved'
                    })
                  })
                }
              })
            })
          }
        })
        this.locale = language
      })
    },
    toggleUserMenu: function () {
      if (!this.userMenu) {
        this.$root.$el.click()
      }
      this.userMenu = !this.userMenu
    },
    toggleVolumeMenu: function () {
      if (!this.volumeMenu) {
        this.$root.$el.click()
      }
      this.volumeMenu = !this.volumeMenu
    },
    testSound: function () {
      SoundService.play()
    },
    toggleMuteSound: function () {
      this.soundMuted = !this.soundMuted
      SoundService.mute(this.soundMuted)
    },
    rootClick: function () {
      this.userMenu = false
      this.volumeMenu = false
    }
  },
  watch: {
    'search': {
      handler: function (val, oldVal) {
        clearTimeout(searchTimer)
        searchTimer = setTimeout(() => {
          this.searchResults = UtilitiesService.propsFilter(this.railObjects, { Name: val })
        }, 100)
      }
    },
    'volume': {
      handler: function (val, oldVal) {
        SoundService.setVolume(val)

        if (parseFloat(val) === 0) {
          SoundService.mute(true)
          this.soundMuted = true
        } else {
          SoundService.mute(false)
          this.soundMuted = false
        }
      }
    },
    'currentUser': {
      immediate: true,
      handler: function (val, oldVal) {
        if (this.currentUser !== null) {
          switch (this.currentUser.OrganisationId) {
            case 46: // Friedrich Hippe
            case 81: // KVB
              this.logo = require('@/assets/logo-railpredict2.png')
              break

            // Default Strukton logo
            default:
              this.logo = require('@/assets/logo-strukton-systems.jpg')
              break
          }
        }
      }
    }
  },
  beforeDestroy: function () {
    this.$root.$el.removeEventListener('click', this.rootClick)
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');

.menu-item-menual {
  color: black;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-right: 20px
}
.menu-item-trackside {
  color: black;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-right: 20px
}

body {
  color: rgba(0,0,0,0.87);
  background-color: #f2f2f2
}

.mouse-pointer {
  cursor: default;
}

.application--wrap > .main-content {
  padding: 64px 0px 0px 400px !important;
}

.top-nav {
  z-index: 10;
  position: relative;
}

form fieldset {
  border: none;
  margin: unset;
  padding: unset;
}

.page-content {
  width: calc(100% - 320px);
  position: relative;
  float: left;
  height: calc(100% - 12px);
  padding-left:10px;
  padding-right:10px;
}

#left-menu {
  width: 80px;
  height: calc(100vh - 64px);
}

#left-sub-menu {
  width: 300px;
  height: calc(100vh - 64px);
}

#content {
  flex: 1 1;
  height: calc(100vh - 64px);
  overflow-x: auto;
  overflow-y: none;
}

.nav-menu {
  padding-top:20px;
  width: 80px;
  height: 100%;
  position: relative;
  float: left;
  background-color: #37474f;
  color: rgba(255, 255, 255, 0.87);
}

.nav-sub-menu {
  padding:10px;
  width: 320px;
  position: relative;
  float: left;
}

.menu-item
{
    position: relative;
    width: 100%;
    text-align: center;
    cursor: pointer;
    border-bottom: 1px solid #37474F;
    padding-top:6px;
    padding-bottom:6px;
    overflow: hidden;
}

.menu-item > i
{
    display: inline-block;
    font-size: 40px;
}

.menu-item > span
{
    display: inline-block;
    font-size: 10px;
    width: 100%;
}

.navigation-drawer--open {
  padding-bottom: 0px !important;
}

.breadcrumbs {
    display: block;
    padding: 0;
    overflow: hidden;
    margin-left: 0;
    list-style: none;
    width:100%;
}

.breadcrumbs>* {
    margin: 0;
    float: left;
    font-size: .8rem;
    line-height: .8rem;
    color: #008cba;
}

.breadcrumbs>*.current a {
    cursor: default;
    color: #333;
}

.breadcrumbs>* a {
    color: #008cba;
}

.breadcrumbs>*:before {
    content: "/";
    color: #aaa;
    margin: 0 .66667rem;
    position: relative;
    top: 1px;
}

#slide-out {
  padding-bottom: 64px;
  margin-top: 64px;
  z-index: -1;
}

.grey-color {
  color: rgba(0, 0, 0, 0.38);
}

.blue-color {
  color: #56CCF2;
}

h5 {
  font-size: 24px;
  font-family:Roboto;
  font-weight: 200;
  font-style: normal;
  line-height: normal;
}

h6 {
  font-size: 20px;
  font-family:Roboto;
  font-weight: 200;
  font-style: normal;
  line-height: normal;
}

p {
  font-family:Roboto;
  font-weight: 100;
}

.progression-cloud {
  background-color: white;
  height: 2px;
  margin: 0px;
}

.white-color-background {
  background-color: white;
}

.blue-color-background {
  background-color: #56CCF2;
}

.tree {
  width: 30px !important;
}

.tree > i {
  margin-right: 0px !important;
}

nav.nav-poss {
  height:56px;
  line-height:56px;
}

nav.nav-poss .nav-wrapper i {
  height: 56px;
  line-height: 56px;
}

.nav-poss .btn-logout {
  height:48px;
  width:48px;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #000;
  text-align: center;
  line-height: 46px;
  font-size: 30px;
  margin-left: 30px;
  margin-right:30px;
  background-color: #fff;
  text-transform: capitalize;
  margin-top: -4px;
}

.nav-poss .btn-logout a {
  padding: 0px;
}

.nav-wrapper .right li:last-child {
  border-left: 1px solid rgba(0, 0, 0, 0.2)
}

.nav-poss ul a i {
  margin-left: 0px;
}

.nav-poss li {
  position: relative;
}

.nav-poss > .nav-wrapper > .col {
  padding-right:0px;
}

.medium-screen {
  display: none;
}

.small-screen {
  display: none;
}

.user-menu {
  width: 256px;
  background-color: #fff;
  z-index: 1000;
  position: absolute;
  line-height: initial;
  color: #000;
  left: -148px;
}

.user-menu td {
  text-align: right;
  padding-right: 20px;
}

.volume-menu {
  width: 655px;
  background-color: #fff;
  z-index: 1000;
  position: absolute;
  line-height: initial;
  color: #000;
  left: -597px;
  height: 130px;
  padding-left: 18px;
  padding-right: 18px;
  padding-top: 13px;
  padding-bottom: 13px;
}

.background-hover {
  position: absolute;
  width: 100%;
  height: 100%;
}

li:hover .background-hover {
  background-color: rgba(0,0,0,0.1);
}

.menu-text {
  font-size: 16px;
  font-family:Roboto;
  font-weight: 200;
  font-style: normal;
  line-height: normal;
  color: rgba(0, 0, 0, 0.87);
}

.menu-text-i {
  font-size: 16px;
  font-family:Roboto;
  font-weight: 200;
  font-style: italic;
  line-height: normal;
  color: rgba(0, 0, 0, 0.56);
}

.row-button {
  text-align: center;
  display: inline-block;
  width: fit-content;
}

.row-button > i {
  float: left;
  height: 20px !important;
  line-height: 20px !important;
  width: fit-content;
  margin-right: 5px;
}

.nav-poss .logo {
  line-height: 62px !important;
  font-size: 36px;
  font-family:Roboto;
  font-weight: 700;
  font-style: normal;
  line-height: normal;
  color: #fff
}

 .language-dropdown {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.38);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border:none;
    outline:none;
  }

  .flag-size {
    width: 32px;
  }

@media only screen and (max-width: 1280px) {
  .large-screen {
    display: none !important;
  }

  .medium-screen {
    display: initial !important;
  }
}

@media only screen and (max-width: 1150px) {
  .large-screen {
    display: none !important;
  }

  .medium-screen {
    display: none !important;
  }

  .small-screen {
    display: initial !important;
  }

  .nav-poss .nav-wrapper .status-placeholder a {
    width: 20px;
  }

  .nav-poss .nav-wrapper .status-placeholder a.tree {
    width: 40px;
  }

  .status-placeholder {
    width: 140px;
  }
}

.fa-spin {
  -webkit-animation: fa-spin 2s infinite linear;
  animation: fa-spin 2s infinite linear;
}
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}

.nav-wrapper > .col {
  display: flex;
  flex-direction: row;
  padding-left: 0px;
}

.nav-wrapper > .col > .gradient {
  flex: 1;
  height: 56px;
  background: linear-gradient(-90deg, #56CCF2, #fff);
}

.nav-wrapper > .col > .right {
  margin-left: auto;
}

.nav-wrapper > .col > .logo {
  padding-left: .75rem;
  padding-right: .75rem;
  background-color: #fff;
  height: 56px;
  color: #000;
}

.logo > img {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/NavBar.vue